<template>
  <section
    v-if="showComponent"
    :id="navigationListId"
    v-observe-visibility="{ callback: isInViewPort, once: true, intersection: { threshold: 0.5 } }"
    class="lb-portal module"
    data-test-navigation-list-outer-wrapper
  >
    <div id="list-container" class="container">
      <div class="row align-center">
        <h2
          v-if="navigationListViewModel.title !== ''"
          class="column small-12 text-center"
          v-html="navigationListViewModel.title"
        />
      </div>
      <div class="row align-center">
        <component
          :is="determineComponentToRender(element.elementTypeEnum)"
          v-for="(element, index) in navigationListViewModel.navigationElements"
          :key="index"
          :element="element"
          :description="navigationListViewModel.description"
          :columns-class="computeColumns"
        />

        <navigation-list-see-more-link
          v-if="showSeeMoreLink"
          :element="navigationListViewModel.seeMoreLink"
          :description="navigationListViewModel.description"
          :columns-class="computeColumns"
        />
      </div>

      <div v-if="navigationListViewModel.bottomContent !== ''" class="row align-center">
        <div class="column small-12 text-center" v-html="navigationListViewModel.bottomContent" />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import NavigationListIconElement from './listElements/NavigationListIconElement.vue';
import NavigationListOverviewElement from './listElements/NavigationListOverviewElement.vue';
import NavigationListSeeMoreLink from './listElements/NavigationListSeeMoreLink.vue';
import NavigationList from './interfaces/NavigationList';
import Utility from '@/common/UtilityFunctions.js';
import { defineComponent } from 'vue';
import axios from 'axios';

export default defineComponent({
  name: 'NavigationList',
  components: {
    NavigationListIconElement,
    NavigationListOverviewElement,
    NavigationListSeeMoreLink
  },
  props: {
    datasource: {
      type: String,
      default() {
        return null;
      }
    }
  },
  data() {
    return {
      navigationListViewModel: {
        title: '',
        description: '',
        navigationElements: null,
        numberOfColumnsPerRow: null,
        seeMoreLink: {
          link: null
        }
      } as NavigationList
    };
  },
  computed: {
    showComponent(): boolean {
      return (
        this.datasource !== '' &&
        this.datasource !== null &&
        this.navigationListViewModel !== null &&
        this.navigationListViewModel.description !== ''
      );
    },
    showSeeMoreLink(): boolean {
      return (
        this.navigationListViewModel.seeMoreLink !== null &&
        this.navigationListViewModel.seeMoreLink.link !== null
      );
    },
    computeColumns(): string | null {
      switch (this.navigationListViewModel.numberOfColumnsPerRow) {
        case 4:
          return 'medium-3';
        case 6:
          return 'medium-4 large-2';
        default:
          return 'medium-4 large-2';
      }
    },
    navigationListId(): string | null {
      if (this.navigationListViewModel.description === null) return '';

      return this.navigationListViewModel.description.replace(/ /g, '-');
    }
  },
  mounted(): void {
    if (this.datasource === null) {
      return;
    }

    axios
      .get(Utility.constants().API.navigation_list + this.datasource)
      .then((response) => {
        this.navigationListViewModel = response.data;
      })
      .catch((error) => {
        Utility.logError(error, this);
      });
  },
  methods: {
    determineComponentToRender(elementTypeEnum: number) {
      switch (elementTypeEnum) {
        case 1:
          return 'navigationListIconElement';
        case 2:
          return 'navigationListOverviewElement';
        default:
          break;
      }
    },
    dispatchLoadTrackingEvent() {
      this.$store.dispatch('Events/register', {
        event: 'navigation-list-load',
        id: 'navigationList',
        vm: Utility.decodeHtml(this.navigationListViewModel.description)
      });
    },
    isInViewPort(isVisible: boolean) {
      if (isVisible) {
        this.dispatchLoadTrackingEvent();
      }
    }
  }
});
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

.lb-portal {
  padding: 0;
}

//needs to be an Id till .container padding-top and- bottom can be overriden
#list-container {
  padding-top: rem-calc(43);
  padding-bottom: rem-calc(43);

  h2 {
    font-size: rem-calc(38);
    margin-bottom: rem-calc(30);
    margin-top: rem-calc(25);

    @media #{$small-only} {
      margin-top: rem-calc(30);
      font-size: rem-calc(26);
    }
  }
}

.modal-content {
  .list-container {
    padding-top: 0;
    padding-bottom: 0;
  }
}
</style>
